const XIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.8035 20.9464C23.0501 21.193 23.1886 21.5274 23.1886 21.8761C23.1886 22.2248 23.0501 22.5592 22.8035 22.8058C22.557 23.0524 22.2226 23.1909 21.8739 23.1909C21.5252 23.1909 21.1907 23.0524 20.9442 22.8058L14 15.8594L7.05355 22.8036C6.80698 23.0502 6.47256 23.1887 6.12386 23.1887C5.77516 23.1887 5.44074 23.0502 5.19417 22.8036C4.9476 22.557 4.80908 22.2226 4.80908 21.8739C4.80908 21.5252 4.9476 21.1908 5.19417 20.9442L12.1406 14L5.19636 7.05359C4.94979 6.80703 4.81127 6.47261 4.81127 6.12391C4.81127 5.77521 4.94979 5.44079 5.19636 5.19422C5.44293 4.94765 5.77735 4.80913 6.12605 4.80913C6.47475 4.80913 6.80917 4.94765 7.05573 5.19422L14 12.1406L20.9464 5.19313C21.1929 4.94656 21.5273 4.80804 21.876 4.80804C22.2247 4.80804 22.5592 4.94656 22.8057 5.19313C23.0523 5.43969 23.1908 5.77411 23.1908 6.12281C23.1908 6.47151 23.0523 6.80593 22.8057 7.0525L15.8593 14L22.8035 20.9464Z"
        fill="white"
      />
    </svg>
  );
};
export default XIcon;
